// S-x: after sign-up the dashboard encourages a second factor — a banner until the login has one. "Agora não" hides it
// in this browser for a while (a convenience: storage may be blocked, then it simply shows again).
import { Link } from '@tanstack/react-router';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSession } from '../lib/session.ts';

const KEY = 'req.mfaBannerDismissedAt';
// PROVISIONAL(P68): how long "Agora não" hides the banner.
export const MFA_BANNER_SNOOZE_DAYS = 30;

const snoozed = (now: number): boolean => {
  try {
    const at = Number(globalThis.localStorage?.getItem(KEY) ?? 0);
    return at > 0 && now - at < MFA_BANNER_SNOOZE_DAYS * 86_400_000;
  } catch {
    return false;
  }
};

export function MfaBanner() {
  const { t } = useTranslation();
  const s = useSession();
  const [hidden, setHidden] = useState(() => snoozed(Date.now()));
  if (s.status !== 'signed_in' || s.me.user.twoFactorEnabled || hidden) return null;
  return (
    <aside aria-label={t('mfaBanner.title')} className="mb-5 flex flex-wrap items-center gap-3 rounded-card border border-line bg-wash px-4 py-3">
      <span className="min-w-0 flex-1 text-sm text-ink">
        <span className="font-semibold">{t('mfaBanner.title')}.</span> {t('mfaBanner.body')}
      </span>
      <Link to="/conta/seguranca" className="text-sm font-semibold">
        {t('mfaBanner.cta')}
      </Link>
      <button
        type="button"
        className="text-sm text-body underline"
        onClick={() => {
          try {
            globalThis.localStorage?.setItem(KEY, String(Date.now()));
          } catch {
            /* blocked storage: hidden for this visit only */
          }
          setHidden(true);
        }}
      >
        {t('mfaBanner.dismiss')}
      </button>
    </aside>
  );
}
